import Api from './Api';

class DatabasesApi extends Api {
  url = 'databases';
}

const singleton = new DatabasesApi();
export default singleton;
